import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Miami needed",
      "Ideal for seasonal residents departing from RSW",
      "Perfect for Caribbean cruise departures",
      "Great for international business travelers",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Collier County post offices",
      "Good for planned international travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at local facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami — no Southwest Florida walk-in",
      "NPIC appointment required before traveling to Miami",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function NaplesProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Naples"
      introText="Naples travelers — whether heading to Europe for a gallery tour, cruising the Caribbean from Fort Lauderdale or Miami, or sending a college student abroad — have several options. Here is how they compare, and why most Gulf Coast residents choose a U.S. Department of State registered passport courier to handle their passport with discretion and speed without the drive across Alligator Alley."
      options={options}
      emergencyDescription="Naples has no regional passport agency. Closest is Miami ~125 mi via I-75/Alligator Alley (2+ hrs). Florida's single agency serves 22M+ residents — the entire state competes for Miami appointments. Snowbird season (Nov–April) effectively doubles demand. I-75 construction and Alligator Alley closures during severe weather can turn 2 hours into 4+."
      disclaimerText="*Processing speed depends on eligibility and documentation. Naples does not have a regional passport agency — the closest is Miami. Not all applicants qualify for Regional Agency Processing."
    />
  );
}